export default __webpack_public_path__ + "static/favicon-ac6606b0e6e55b1bb92ebf995d8a961d.png";